module.exports = __webpack_public_path__ + "static/how-it-works-info-9be3ad25a31c560a01d4c0dfa6eb6c1b.jpg";